import { Youtube, Instagram, Facebook, Send } from "lucide-react";
import { useSiteLinks } from "@/hooks/useSiteLinks";

interface SocialIconsBarProps {
  size?: number;
  className?: string;
  iconClassName?: string;
}

const TikTokIcon = ({ size = 18 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const SocialIconsBar = ({ size = 18, className = "", iconClassName = "" }: SocialIconsBarProps) => {
  const { links } = useSiteLinks();

  const socials = [
    { name: "YouTube", url: "https://www.youtube.com/channel/UCp-FFrQmsqueLZ-IYg3kCiw", Icon: () => <Youtube size={size} /> },
    { name: "Telegram", url: links.join_telegram || "https://t.me/fitawrarifx", Icon: () => <Send size={size} /> },
    { name: "Instagram", url: "https://www.instagram.com/fitawrarifx/", Icon: () => <Instagram size={size} /> },
    { name: "TikTok", url: "https://www.tiktok.com/@fitawrarifx", Icon: () => <TikTokIcon size={size} /> },
    { name: "Facebook", url: "https://www.facebook.com/fitawrarifx/", Icon: () => <Facebook size={size} /> },
  ];

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {socials.map(({ name, url, Icon }) => (
        <a
          key={name}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={name}
          className={`text-muted-foreground hover:text-foreground transition-colors ${iconClassName}`}
        >
          <Icon />
        </a>
      ))}
    </div>
  );
};

export default SocialIconsBar;
